// extracted by mini-css-extract-plugin
module.exports = {"csrContact":"_3x6Z24MkYDfRVd9IB6sv5E"};